import React, { useState } from 'react';
import { authService } from '../services/auth';
import { toast } from 'react-toastify';
import './Register.css';

const Register = ({ onSuccess, onBackToLanding, onLoginClick }) => {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            setLoading(true);
            const res = await authService.register({ name, email, password });
            // El backend envía un mensaje para que el usuario verifique su email
            toast.success(res?.message || 'Registro exitoso. Revisa tu correo para verificar tu cuenta');
            // Volver al inicio o a la pantalla de login
            if (onBackToLanding) onBackToLanding();
        } catch (err) {
            toast.error(err?.response?.data?.error || err.message || 'Error al registrarse');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="auth-form">
            <button type="button" className="btn-back" onClick={onBackToLanding}>
                ← Volver al inicio
            </button>

            <h2>Crear cuenta</h2>
            <form onSubmit={handleSubmit}>
                <div className="form-group">
                    <label>Nombre</label>
                    <input type="text" value={name} onChange={(e) => setName(e.target.value)} required />
                </div>
                <div className="form-group">
                    <label>Email</label>
                    <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
                </div>
                <div className="form-group">
                    <label>Contraseña</label>
                    <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
                </div>
                <button type="submit" disabled={loading} className="btn-primary">
                    {loading ? 'Registrando...' : 'Crear cuenta'}
                </button>
                <p className="auth-footer">
                    ¿Ya tienes cuenta? <span onClick={onLoginClick}>Inicia sesión</span>
                </p>
            </form>
        </div>
    );
};

export default Register;
